/**
 * All API access is provided through these functions.
 */

const axios = require('axios').default;

const API_BASE = process.env.VUE_APP_API_BACKEND

let postLogin = async (payload) => {
    /**
     * Payload tbd (user + pass).
     */
    const resp = await axios.post(
        API_BASE + '/login',
        payload);
    return resp.data  // {token: <token>}
};

let getUsers = async (token) => {
    const resp = await axios.get(
        API_BASE + '/list_users',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data  // {???}
}


let getSgGroups = async (token) => {
    const resp = await axios.get(
        API_BASE + '/list_groups',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data  // {???}
}


let postRegister = async (token, payload) => {
    /**
     * Payload =
     */
    const resp = await axios.post(
        API_BASE + '/register',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

let postDeleteUser = async (token, username) => {
    let payload = {
        username: username
    }
    const resp = await axios.post(
        API_BASE + '/unregister',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}


let postChangePassword = async (token, payload) => {
    /**
     * payload = {password (current), newPassword}
     */
    const resp = await axios.post(
        API_BASE + '/change_pass',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}


let postModifyUser = async (token, payload) => {
    /**
     * payload = {username, password (optional), role (opional)}
     */
    const resp = await axios.post(
        API_BASE + '/manage_users',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

let getProfile = async (token) => {
    const resp = await axios.get(
        API_BASE + '/profile',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data  // {???}
}

const postValidateExcel = async (token, category, formData, requestConfig) => {
    const resp = await axios.post(
        API_BASE + `/ingest/validate/${category}`,
        formData,
        {
            "headers": {
                'jwt-token': token,
                'Content-Type': 'multipart/form-data'
            },
            ...requestConfig
        }
    );
    return resp.data
}


const postSubmitExcel = async (token, category, formData, requestConfig) => {
    const resp = await axios.post(
        API_BASE + `/ingest/submit/${category}`,
        formData,
        {
            "headers": {
                'jwt-token': token,
                'Content-Type': 'multipart/form-data'
            },
            ...requestConfig
        }
    );
    return resp.data
}

const postValidatePublish = async (token, category, versionItems) => {
    let payloadData = []
    Object.values(versionItems).forEach(versionItem => {
        let versionPayload = {}
        Object.assign(versionPayload, versionItem.metadata)
        versionPayload.files = versionItem.files.map(f => {
            let fpath = f.webkitRelativePath ? f.webkitRelativePath : f.name;
            let fparts = fpath.split("/");
            return fparts[fparts.length - 1]
        })
        payloadData.push(versionPayload)
    })
    let payload = {
        category: category,
        data: payloadData
    }
    const resp = await axios.post(
        API_BASE + `/publish/validate`,
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const postSubmitPublish = async (token, category, versionItems) => {
    let payloadData = []
    Object.values(versionItems).forEach(versionItem => {
        let versionPayload = {}
        Object.assign(versionPayload, versionItem.metadata)
        versionPayload.files = versionItem.files.map(f => {
            let fpath = f.webkitRelativePath ? f.webkitRelativePath : f.name;
            let fparts = fpath.split("/");
            if(fparts.length <= 2){
                return fparts[fparts.length - 1]  // return fname only
            }
            // Strip off root + version dir; allow subdirs in keys
            return fparts.slice(2).join("/")  // return with subdir
        })
        payloadData.push(versionPayload)
    })
    let payload = {
        category: category,
        data: payloadData
    }
    const resp = await axios.post(
        API_BASE + `/publish/start`,
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const postSubmitThumbnail = async (token, category, versionId, formData, requestConfig) => {
    // /publish/thumbnail/<category>/<int:version_id>
    const resp = await axios.post(
        API_BASE + `/publish/thumbnail/${category}/${versionId}`,
        formData,
        {
            "headers": {
                'jwt-token': token,
                'Content-Type': 'multipart/form-data'
            },
            ...requestConfig
        }
    );
    return resp.data
}

const postFinalizePublish = async (token, category, sgVersionIds) => {
    let versions = Object.keys(sgVersionIds).map(verStr => parseInt(verStr))
    let payload = {
        category: category,
        versions: versions
    }
    const resp = await axios.post(
        API_BASE + `/publish/finalize`,
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const postS3Object = async (fileObj, url, fields, requestConfig) => {
    let formData = new FormData()
    // NOTE: FILE MUST BE SPECIFIED LAST. I WON'T GET THAT HOUR BACK
    //  BUT HOPEFULLY THIS SAVES YOURS
    Object.keys(fields).forEach(key => {
        formData.append(key, fields[key]);
    });
    formData.append("file", fileObj, fileObj.name);
    const resp = await axios.post(
        url,
        formData,
        {
            "headers": {
                'Content-Type': 'multipart/form-data'
            },
            ...requestConfig
        }
    );
    return resp.data
}

// Presigned put
const putS3Object = async (fileObj, url, requestConfig) => {
    const resp = await axios.put(
        url,
        {  // data param
            data: fileObj,
        },
        {  // config param
            ...requestConfig
        }
    );
    return resp.data
}


const getListingTypes = async (token) => {
    const resp = await axios.get(
        API_BASE + '/emailconf/listing',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const postListingTypes = async (token, entries) => {
    let payload = {
        data: entries
    }
    const resp = await axios.post(
        API_BASE + '/emailconf/listing',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const getPrivateLabels = async (token) => {
    const resp = await axios.get(
        API_BASE + '/emailconf/private_label',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const postPrivateLabels = async (token, entries) => {
    let payload = {
        data: entries
    }
    const resp = await axios.post(
        API_BASE + '/emailconf/private_label',
        payload,
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data
}

const getApiVersion = async (token) => {
    try {
        const resp = await axios.get(
            API_BASE + '/api_version',
            {
                "headers": {
                    'jwt-token': token
                }
            }
        );
        return resp.data
    } catch (err) {
        return "1.0.0"
    }
}

const getAllowedProjects = async (token) => {
    const resp = await axios.get(
        API_BASE + '/list_allowed_projects',
        {
            "headers": {
                'jwt-token': token
            }
        }
    );
    return resp.data.project_list
}

export default {
    postLogin,
    getUsers,
    getSgGroups,
    postRegister,
    postDeleteUser,
    postChangePassword,
    postModifyUser,
    getProfile,
    postValidateExcel,
    postSubmitExcel,
    postValidatePublish,
    postSubmitPublish,
    postSubmitThumbnail,
    postFinalizePublish,
    postS3Object,
    putS3Object,
    getListingTypes,
    postListingTypes,
    getPrivateLabels,
    postPrivateLabels,
    getApiVersion,
    getAllowedProjects
}